import { useState } from 'react';
import { default as Box } from '@mui/material/Box';
import { Text } from 'components/Text';
import { SizedBox } from './SizedBox';

interface Props {
  videoUrl: string;
}

export const Video = ({ videoUrl }: Props) => {
  const [hasError, setHasError] = useState(false);

  const getVideoType = (url: string): string => {
    if (url.endsWith('.mov')) return 'video/quicktime';
    if (url.endsWith('.mp4') || url.endsWith('.MP4')) return 'video/mp4';
    return 'video/mp4';
  };

  const handleError = () => {
    setHasError(true);
  };

  if (hasError) {
    return (
      <SizedBox>
        <Box mb={2}>
          <Text variant="body2" color="error">
            Video could not be loaded. Please check your connection or try again
            later.
          </Text>
        </Box>
      </SizedBox>
    );
  }

  if (!videoUrl) {
    return null;
  }

  return (
    <SizedBox>
      <Box mb={2}>
        <video
          controls
          playsInline
          preload="metadata"
          onError={handleError}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            maxWidth: '100%'
          }}
        >
          <source src={videoUrl} type={getVideoType(videoUrl)} />
          Your browser does not support the video tag.
        </video>
      </Box>
    </SizedBox>
  );
};
